<template>
  <div class="product-details-content-setup-step-01">
    <snow-switch
      id="is-zeuspay-members"
      class="mb-4"
      label="Ativar área de membros"
      v-model="isZeuspayMembers"
      :disabled="!form.subdomain"
      :info="
        !form.subdomain
          ? 'Cadastre um subdomínio para ativar sua área de membros'
          : ''
      "
    />
    <snow-input
      v-model="form.name"
      id="name"
      label="Nome da área de membros"
      placeholder="Alunos"
      :errors="errors.name"
      required
    />
    <div class="d-flex justify-content-end mb-4">
      <small
        class="text-secondary"
        :class="{
          'text-danger': form.name && form.name.length > 250
        }"
      >
        {{ `${form.name ? form.name.length : 0}/250` }}
      </small>
    </div>

    <snow-input
      v-model="form.description"
      id="description"
      label="Descrição (SEO)"
      :errors="errors.description"
      info="A Descrição é o texto geralmente exibido pelo Google nas segundas e
        terceiras linhas dos resultados de busca. Crie uma Descrição que
        estimule o interesse das pessoas em saber mais sobre o seu conteúdo."
      type="textarea"
      rows="4"
      required
    />
    <div class="d-flex justify-content-end">
      <small
        class="text-secondary"
        :class="{
          'text-danger': form.description && form.description.length > 255
        }"
      >
        {{ `${form.description ? form.description.length : 0}/255` }}
      </small>
    </div>

    <snow-switch
      id="showcase"
      class="mb-4"
      label="Exibir na vitrine"
      v-model="form.showcase"
      switch
    />

    <snow-input
      v-if="form.showcase"
      v-model="form.link_sale_page"
      id="link-sale-page"
      label="Link da página de vendas"
      info="Insira o link de uma página que descreva seu curso. Essa informação é"
      :errors="errors.link_sale_page"
    />

    <h5 class="text-semibold mb-4 pt-4">
      Personalização de domínio
    </h5>
    <div class="d-flex align-items-end mb-4">
      <snow-input
        v-model="form.subdomain"
        id="subdomain"
        label="Subdomínio"
        class="flex-fill"
        :errors="errors.subdomain"
        setFocusOnError
        required
      />
      <strong class="pl-3">
        .zeusmembers.club
      </strong>
    </div>

    <snow-input
      v-model="form.domain"
      id="domain"
      label="Domínio próprio (opcional)"
      class="flex-fill"
      :errors="errors.domain"
      info="Necessário ajustar o CNAME do domínio para cname.zeuspay.com.br"
      setFocusOnError
    />

    <h5 class="text-semibold mb-4 pt-4">
      Prazo de acesso na área de membros
    </h5>
    <div class="d-flex mb-4">
      <snow-select
        class="flex-fill"
        id="access_period"
        label="Período de acesso"
        v-model="form.access_period"
        :options="periodOptions"
        :errors="errors.access_period"
      />
      <snow-input
        v-show="form.access_period != 'unlimited_access'"
        class="ml-3 flex-fill"
        id="access_unit"
        mask="####"
        :label="`${periodPt[form.access_period]} de acesso`"
        v-model="form.access_unit"
        :errors="errors.access_unit"
      />
    </div>

    <h5 class="text-semibold mb-4 pt-4">
      Definição de Senha Padrão
    </h5>
    <snow-input
      v-model="form.password_default"
      id="password_default"
      class="mb-4"
      label="Configure uma senha de acesso a sua Área de Membros. Válida apenas para alunos."
      :errors="errors.password_default"
    />
    <h5 class="text-semibold pt-4 mb-4">
      Redes Sociais
    </h5>
    <snow-switch
      id="social-media-members"
      v-model="form.social_media_enabled"
      label="Ativar redes sociais na área de membros"
      class="mb-4"
      :class="{ 'text-primary': form.social_media_enabled }"
    />

    <div class="d-flex flex-column gap-4" v-if="form.social_media_enabled">
      <snow-input
        v-model="form.social_media.instagram"
        id="instagram_url"
        label="Instagram"
        icon="ph ph-instagram-logo"
      />
      <snow-input
        v-model="form.social_media.facebook"
        id="facebook_url"
        icon="ph ph-facebook-logo"
        label="Facebook"
      />
      <snow-input
        v-model="form.social_media.youtube"
        id="youtube_url"
        icon="ph ph-youtube-logo"
        label="Youtube"
      />
    </div>
  </div>
</template>

<script>
// import { getToken } from "@/setup/api";
import { mapState } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async updateMembers(val) {
      const { data } = await this.$store.dispatch("product/put", {
        id: this.$route.params.id,
        is_zeuspay_members: val
      });

      this.$store.commit("product/setProduct", data);
    }
  },
  computed: {
    ...mapState("product", ["product"]),
    isZeuspayMembers: {
      get() {
        return this.product?.is_zeuspay_members;
      },
      set(val) {
        this.updateMembers(val);
      }
    },
    periodOptions() {
      return [
        { id: "unlimited_access", name: "Ilimitado" },
        { id: "days", name: "Dias" },
        { id: "months", name: "Meses" },
        { id: "years", name: "Anos" }
      ];
    },
    periodPt() {
      return {
        unlimited_access: "Ilimitado",
        days: "Dias",
        months: "Meses",
        years: "Ano"
      };
    }
  },
  watch: {
    "form.access_period"(val) {
      if (val === "unlimited_access") {
        this.form.access_unit = null;
      }
    },
    "form.social_media_enabled"(val) {
      if (val === false) {
        this.form.social_media = {
          instagram: "",
          facebook: "",
          youtube: ""
        };
      }
    }
  }
};
</script>
